"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.knowledgeBaseArticleService = void 0;
const knowledge_base_article_service_1 = require("./knowledge-base-article-service");
const query_client_1 = require("../query-client");
exports.knowledgeBaseArticleService = new knowledge_base_article_service_1.KnowledgeBaseArticleService({
    resource: 'knowledge-base-article',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
